import { Injectable } from '@angular/core';
import {
  BlobServiceClient,
  ContainerClient,
  BlockBlobClient,
} from '@azure/storage-blob';
import { environment } from 'environment/environment';

@Injectable({
  providedIn: 'root',
})
export class BlobUploadService {
  private readonly sasString: string = environment.azureBlobSasString;
  private readonly containerName: string = 'client-logos';
  private readonly blobServiceClient: BlobServiceClient;
  private readonly containerClient: ContainerClient;

  constructor() {
    this.blobServiceClient = new BlobServiceClient(
      `${environment.azureBlobStorage}?${this.sasString}`
    );
    this.containerClient = this.blobServiceClient.getContainerClient(
      this.containerName
    );
  }

  public async uploadFile(file: File): Promise<string> {
    const blockBlobClient: BlockBlobClient =
      this.containerClient.getBlockBlobClient(file.name);
    const options = {
      blobHTTPHeaders: { blobContentType: file.type },
    };

    try {
      await blockBlobClient.upload(file, file.size, options);
      return blockBlobClient.url;
    } catch (error) {
      console.error('Upload failed:', error);
      throw error;
    }
  }

  public async deleteFile(fileName: string): Promise<void> {
    const blockBlobClient: BlockBlobClient =
      this.containerClient.getBlockBlobClient(fileName);

    try {
      await blockBlobClient.delete();
      console.log(`File ${fileName} deleted successfully.`);
    } catch (error) {
      console.error('Delete failed:', error);
      throw error;
    }
  }

  public getUrlByName(fileName: string): string {
    return `${environment.azureBlobStorage}/${this.containerName}/${fileName}?${this.sasString}`;
  }
}
